<template>
  <div>
    <Spinner ref="spinner" :block="true"/>
    <div class="p-4" v-if="seller">
      <div class="form-group">
        <router-link :to="{ name: 'sellers' }" class="btn btn-outline-info mr-2">
          <i class="icon-arrow-left"></i> Voltar
        </router-link>
      </div>
      <div class="row">
        <div class="col-lg-3 col-lg-pull-6 col-md-6 col-sm-6">
          <div class="row mx-0">
            <div class="card" style="width:100%">
              <div class="card-content">
                <div class="form-group">
                  <div class="profile-side">
                    <div class="profile-card">
                      <div class="profile-card-photo">
                        <img src="@/assets/img/user-unknown.png" alt="User photo">
                      </div>
                      <span class="badge badge-pill mb-1" :class="(seller.registrationOrigin === null) ? 'badge-dark' : ((seller.registrationOrigin.isPartner) ? 'badge-partner' : 'badge-homeSeller')">  {{ (seller.registrationOrigin != null) ? `${seller.registrationOrigin.application}` : `Aplicação não encontrada` }} </span>
                      <div class="profile-card-name"> {{ seller.holder.fullName }}</div>
                      <div class="profile-card-location">
                        <span>
                        {{ seller.holder.taxDocument }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="card" style="width:100%">
              <div class="card-content">
                <h3 class="font-weight-light ml-3">Informações</h3>
                <hr>
                <p class="m-3">
                  <i class="icon-location-pin"></i>
                  {{ formatAddress(seller.address) }}
                </p>
                <p v-if="seller.holder.phone || seller.holder.mobile" class="m-3">
                  <i class="icon-phone"></i>
                  {{ seller.holder.phone }}
                  <span v-if="seller.holder.mobile">/</span>
                  {{ seller.holder.mobile }}
                </p>
                <p v-if="seller.holder.birthDate" class="m-3">
                  <i class="icon-calendar"></i>
                  {{ seller.holder.birthDate | date }}
                </p>
                <p v-if="seller.holder.email" class="m-3">
                  <i class="icon-envelope-letter"></i>
                  {{ seller.holder.email }}
                </p>
                <p v-if="seller.holder.company" class="m-3">
                  <i class="icon-briefcase"></i>
                  <span v-if="!seller.financialConstraints || !seller.financialConstraints.juridicalPerson">
                  {{ seller.holder.company.taxDocument }}
                  </span>
                  <span class="cursor color-red" v-if="seller.financialConstraints && seller.financialConstraints.juridicalPerson">
                  {{ seller.holder.company.taxDocument }}
                  <i class="fa fa-exclamation"></i>
                  </span>
                  <br /> Nome Fantasia: {{ seller.holder.company.tradeName }}
                  <br /> Razão Social: {{ seller.holder.company.fullName }}
                </p>
                <p v-if="seller.holder.fullName" class="m-3">
                  Pessoa Física: {{ seller.holder.fullName }}
                </p>
                <p v-if="seller.account.comercialName" class="m-3">
                  Nome Comercial: {{ seller.account.comercialName}}
                </p>
                <p v-if="seller.businessActivity" class="m-3">
                  <i class="fa fa-building"></i>
                  {{ seller.businessActivity.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="card" style="width:100%">
              <div class="card-content">
                <h3 class="font-weight-light ml-3">Dados bancários</h3>
                <hr>
                <div v-if="seller.bankAccount">
                  <p class="m-3">{{ seller.bankAccount.bankName }}</p>
                  <p class="m-3">C/{{ seller.bankAccount.type }} {{ seller.bankAccount.accountNumber }}</p>
                  <p class="m-3">Agência {{ seller.bankAccount.bankBranchNumber }}</p>
                </div>
                <div v-if="!seller.bankAccount">
                  <p class="m-3">Dados não informados</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-lg-push-3 col-md-12">
          <div class="row mx-0" v-if="center != null && (northeast != null || southwest != null)">
            <div class="col-12 card" style="with:100%">
              <div class="card-content">
                <h3 class="font-weight-light ml-3">Mapa</h3>
                <hr>
                <gmap-map :center="center" :zoom="zoom" :options="mapOptions" style="height: 775px;">
                  <gmap-marker :clickable="true" :traceable="false" :position="northeast" :title="northeast.label" :icon="{ url: northeast.icon }"></gmap-marker>
                  <gmap-marker :clickable="true" :traceable="false" :position="southwest" :icon="{ url: southwest.icon }"></gmap-marker>
                </gmap-map>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="row mx-0">
            <div class="card" style="width:100%">
              <div class="card-content">
                <h3 class="font-weight-light ml-3">Ações</h3>
                <hr>
                <div class="box-typical-inner p-a-md">
                  <button v-if="seller.account && !seller.account.approved && !seller.account.reproved" type="button" class="btn btn-success btn-md btn-block mb-2 mx-auto" @click.prevent="approve">
                  <i class="fa fa-check"></i>
                    Aprovar
                  </button>
                  <button v-if="seller.account && !seller.account.approved && !seller.account.reproved" type="button" class="btn btn-danger btn-md btn-block mb-2 mx-auto" @click.prevent="disapprove">
                  <i class="fa fa-ban"></i>
                    Reprovar
                  </button>
                  <button v-if="seller.account && !seller.account.approved && !seller.account.reproved && !seller.holder.blacklist" type="button" class="btn btn-pending btn-md btn-block mb-2 mx-auto" @click.prevent="notify">
                  <i class="fa fa-comment-o"></i>
                    Pendente de documentos
                  </button>
                  <button v-if="seller.account.approved && !seller.account.active" type="button" class="btn btn-cpfcomplete btn-md btn-block mb-2 mx-auto" @click.prevent="activate">
                  <i class="fa fa-thumbs-o-up"></i>
                    Reativar conta
                  </button>
                  <button v-if="seller.account.approved && seller.account.active" type="button" class="btn btn-delayed btn-md btn-block mb-2 mx-auto" @click.prevent="deactivate">
                  <i class="fa fa-thumbs-o-down"></i>
                    Encerrar conta
                  </button>
                  <button v-if="seller.account && seller.account.active && seller.account.approved && !seller.account.balanceBlocked" type="button" class="btn btn-typed btn-md btn-block mb-2 mx-auto" @click.prevent="blockBalance">
                  <i class="fa fa-lock"></i>
                    Bloquear saldo
                  </button>
                  <button v-if="seller.account && seller.account.active && seller.account.approved && seller.account.balanceBlocked" type="button" class="btn btn-cnpjlocalization btn-md btn-block mb-2 mx-auto" @click.prevent="unblockBalance">
                  <i class="fa fa-unlock"></i>
                    Desbloquear saldo
                  </button>
                  <button v-if="seller.account && !seller.holder.blacklist" type="button" class="btn btn-dark btn-md btn-block mb-2 mx-auto" @click.prevent="blacklist">
                  <i class="fa fa-lock"></i>
                    Adicionar na blacklist
                  </button>
                  <button v-if="seller.account && seller.holder.blacklist" type="button" class="btn btn-sucess btn-md btn-block mb-2 mx-auto" @click.prevent="whitelist">
                  <i class="fa fa-unlock"></i>
                    Retirar da blacklist
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0" v-if="seller.account.reproved">
            <div class="card" style="width:100%">
              <div class="card-content">
                <h3 class="font-weight-light ml-3">Motivos de Reprovação</h3>
                <hr>
                <p class="ml-3" v-for="(reason, index) of this.seller.reason" :key="index">
                  <span>{{ reason }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="row mx-0" v-if="timeline">
            <div class="card" style="width:100%">
              <div class="card-content">
                <h3 class="font-weight-light ml-3">Timeline</h3>
                <hr>
                <ul class="timeline scrollable-block scrollable-timeline">
                  <li v-for="log of timeline" :key="log.executedAt">
                    <span>{{ log.executedBy | abbreviateName(20) }}</span>
                    <span class="float-right"> {{ log.executedAt | datetime }} </span>
                    <p> {{ badgeTimeline(log.actionType) }} </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div class="card col-12">
        <div class="card-content">
          <h3 class="font-weight-light ml-3">Documentos</h3>
          <hr>
          <div v-if="(selfie.display !== '') && (documentFront.display !=='')" class="text-center">
            <img :src="selfie.display" class="rounded camera-size ml-5" />
            <img :src="documentFront.display" class="rounded camera-size ml-5" />
            <img :src="documentBack.display" class="rounded camera-size ml-5" />
          </div>
          <div v-else>
            <p class="m-3">Documentos não enviados</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div class="card col-12">
        <div class="card-content">
          <h3 class="font-weight-light ml-3">Análise de Risco</h3>
          <hr>
          <div class="table-responsive">
            <table class="table table-strip">
              <thead>
                <th class="text-center">Data da Consulta</th>
                <th class="text-center">Score</th>
                <th class="text-center">Descrição</th>
                <th class="text-center">Email existe?</th>
                <th class="text-center">Domínio existe?</th>
                <th class="text-center">Risco do domínio</th>
              </thead>
              <tbody>
                <tr :id="index" v-for="(analyis, index) in analisys" :key="analyis.index">
                  <td class="text-center">{{ analyis.analyzedAt | datetime }}</td>
                  <td class="text-center">{{ analyis.email.riskScore }}</td>
                  <td class="text-center">{{ analyis.email.fraudRiskDescription }}</td>
                  <td class="text-center">
                    <i v-if="analyis.email.exists" class="fa fa-check text-success" aria-hidden="true"></i>
                    <i v-else class="fa fa-times text-danger" aria-hidden="true"></i>
                  </td>
                  <td class="text-center">
                    <i v-if="analyis.domain.exists" class="fa fa-check text-success" aria-hidden="true"></i>
                    <i v-else class="fa fa-times text-danger" aria-hidden="true"></i>
                  </td>
                  <td class="text-center">{{ analyis.domain.riskLevel }}</td>
                </tr>
                <tr v-if="analisys.length == 0">
                  <td colspan="5">
                    Nenhuma ocorrência encontrada.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AccountApi from '@/services/AccountApi'
import MapsApi from '@/services/MapsApi'
import IpApi from '@/services/IpApi'
import HolderError from '@/errors/HolderError'
import swal from 'sweetalert2'
import AntifraudApi from '@/services/AntifraudApi'

export default {
  name: 'SellerDatail',
  async mounted () {
    await this.find()
  },
  data () {
    return {
      count: 0,
      center: null,
      seller: null,
      northeast: {
        label: '',
        icon: '',
        lat: 0,
        lng: 0
      },
      southwest: {
        label: '',
        icon: '',
        lat: 0,
        lng: 0
      },
      timeline: [],
      zoom: null,
      mapOptions: {
        scrollwheel: true,
        streetViewControl: false,
        zoomControl: true,
        gestureHandling: 'cooperative',
        mapTypeControl: false,
        fullscreenControl: true
      },
      selfie: {
        display: '',
        image: ''
      },
      documentFront: {
        display: '',
        image: ''
      },
      documentBack: {
        display: '',
        image: ''
      },
      analisys: []
    }
  },
  methods: {
    async activate () {
      swal({
        title: 'Ativar conta',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Ativar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          const api = new AccountApi()
          const result = await api.antifraud.activate(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$alert.error('Ops', error)
          } else {
            this.$bus.$emit('spinner-stop')
            this.isDisabled = true
            this.$alert.info('Pronto', 'Conta ativada!')
            await this.find()
          }
        }
      })
    },
    async approve () {
      this.$alert.question(`Aprovar conta`, `Aprovar conta do usuário ${this.seller.holder.fullName}?`)
      this.$alert.onConfirm = async () => {
        this.$bus.$emit('spinner-run')
        const api = new AccountApi()
        const result = await api.antifraud.approve(this.seller.holder.id)
        if (result.error) {
          const modelError = new HolderError(result)
          const error = modelError.getMessage()
          this.$alert.error('Ops', error)
        } else {
          this.isDisabled = true
          await this.find()
          this.$bus.$emit('spinner-stop')
          this.$alert.info('Pronto', 'Conta aprovada!')
        }
      }
    },
    async blacklist () {
      swal({
        title: 'Bloquear por suspeita de fraude',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Bloquear',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          const api = new AccountApi()
          const result = await api.antifraud.blacklist(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$alert.error('Ops', error)
          } else {
            this.$bus.$emit('spinner-stop')
            this.isDisabled = true
            await this.find()
            this.$alert.info('Pronto', 'Conta adicionada a blacklist.')
          }
        }
      })
    },
    async whitelist () {
      swal({
        title: 'Desbloquear por suspeita de fraude',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Desbloquear',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          const api = new AccountApi()
          const result = await api.antifraud.whitelist(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$alert.error('Ops', error)
          } else {
            this.isDisabled = true
            this.$bus.$emit('spinner-stop')
            await this.find()
            this.$alert.info('Pronto', 'Conta retirada da blacklist.')
          }
        }
      })
    },
    async blockBalance () {
      swal({
        title: 'Bloquear saldo',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Bloquear',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          const api = new AccountApi()
          const result = await api.antifraud.block(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$alert.error('Ops', error)
          } else {
            this.$bus.$emit('spinner-stop')
            this.isDisabled = true
            this.$alert.info('Pronto', 'Saldo bloqueado!')
            await this.find()
          }
        }
      })
    },
    async deactivate () {
      swal({
        title: 'Encerrar conta',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Encerrar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          const api = new AccountApi()
          const result = await api.antifraud.deactive(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$alert.error('Ops', error)
          } else {
            this.$bus.$emit('spinner-stop')
            this.isDisabled = true
            this.$alert.info('Pronto', 'Conta encerrada!')
            await this.find()
          }
        }
      })
    },
    async notify () {
      swal({
        title: 'Notificar',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Notificar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          this.$bus.$emit('spinner-run')
          const api = new AccountApi()
          const result = await api.antifraud.notify(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$bus.$emit('spinner-stop')
            this.$alert.error('Ops', error)
          } else {
            this.isDisabled = true
            await this.find()
            this.$bus.$emit('spinner-stop')
            this.$alert.info('Pronto', 'Notificação enviada!')
          }
        }
      })
    },
    async unblockBalance () {
      swal({
        title: 'Desbloquear saldo',
        text: 'Qual o motivo?',
        type: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Motivo',
        inputAttributes: {
          minlength: 2,
          maxlength: 255,
          autocapitalize: 'off'
        },
        confirmButtonText: 'Desbloquear',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason || reason.length === 0) {
            swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.reason = reason
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss && res.dismiss === 'cancel') {
          return !swal.isLoading()
        } else {
          const api = new AccountApi()
          const result = await api.antifraud.unblock(this.seller.holder.id, this.reason)
          if (result.error) {
            const modelError = new HolderError(result)
            const error = modelError.getMessage()
            this.$alert.error('Ops', error)
          } else {
            this.$bus.$emit('spinner-stop')
            this.isDisabled = true
            this.$alert.info('Pronto', 'Saldo desbloqueado!')
            await this.find()
          }
        }
      })
    },
    async find () {
      await this.getAnalisys()

      const api = new AccountApi()
      const result = await api.sellers.find(this.$route.params.id)
      if (!result.error) {
        this.seller = result
        await this.history()
        if (this.seller.registrationOrigin) {
          this.setDataLocation(this.seller.registrationOrigin.ip, this.formatAddressForGoogleApi(this.seller.address))
        }
      }
      await api.sellers.findSelfie(this.$route.params.id).then((response) => {
        if (response.status === 422) {
          this.selfie.image = ''
          this.selfie.display = ''
        } else {
          this.selfie.image = new File([response.data], {
            type: 'image/png'
          })
          this.selfie.display = URL.createObjectURL(this.selfie.image)
        }
      })

      await api.sellers.findDocumentFront(this.$route.params.id).then((response) => {
        if (response.status === 422) {
          this.documentFront.image = ''
          this.documentFront.display = ''
        } else {
          this.documentFront.image = new File([response.data], {
            type: 'image/png'
          })
          this.documentFront.display = URL.createObjectURL(this.documentFront.image)
        }
      })

      await api.sellers.findDocumentBack(this.$route.params.id).then((response) => {
        if (response.status === 422) {
          this.documentBack.image = ''
          this.documentBack.display = ''
        } else {
          this.documentBack.image = new File([response.data], {
            type: 'image/png'
          })
          this.documentBack.display = URL.createObjectURL(this.documentBack.image)
        }
      })
    },
    async setDataLocation (ip, address) {
      const locationIp = await this.addressByIp(ip)
      const addressLocation = await this.coordenatesByAddress(address)

      if (locationIp.lat == null && addressLocation.lat == null) {
        return
      }

      if (locationIp.lat != null && addressLocation.lat != null) {
        if (locationIp.lat < addressLocation.lat) {
          this.northeast = locationIp
          this.southwest = addressLocation
        } else {
          this.northeast = addressLocation
          this.southwest = locationIp
        }
      } else {
        if (locationIp.lat != null) {
          this.northeast = locationIp
        } else {
          this.northeast = addressLocation
        }
      }
      this.setZoomConfig()
    },
    async addressByIp (ip) {
      const ipApi = new IpApi()
      const result = await ipApi.addressByIp(ip)
      const location = {}
      location.label = 'Endereço usado para efetuar o cadastro'
      location.icon = 'http://cdn.dev.pagcerto.com.br/img/markers/marker-ip.png'
      location.lat = result.lat
      location.lng = result.lon
      return location
    },
    async coordenatesByAddress (address) {
      const mapsApi = new MapsApi()
      const result = await mapsApi.getCoordenates(address)
      const location = {}
      location.label = 'Endereço informado'
      location.icon = 'http://cdn.dev.pagcerto.com.br/img/markers/marker-address.png'
      location.lat = result.results.length > 0 ? result.results[0].geometry.location.lat : null
      location.lng = result.results.length > 0 ? result.results[0].geometry.location.lng : null
      return location
    },
    calcZoom () {
      let radius = this.getDistanceFromLatLonInKm()
      return Math.round(16 - Math.log(radius) / Math.LN2)
    },
    deg2rad (deg) {
      return deg * (Math.PI / 180)
    },
    getDistanceFromLatLonInKm () {
      let R = 6371 // Radius of the earth in km or 3958.75 miles
      let dLat = this.deg2rad(this.southwest.lat - this.northeast.lat)
      let dLon = this.deg2rad(this.southwest.lng - this.northeast.lng)
      let a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(this.northeast.lat)) * Math.cos(this.deg2rad(this.southwest.lat)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      let d = R * c // Distance in km
      return d
    },
    getCenterLocationFromLatLon (orig, dest) {
      return orig - ((orig - dest) / 2)
    },
    setZoomConfig () {
      if (this.northeast && this.southwest) {
        this.center = {
          lat: this.getCenterLocationFromLatLon(this.northeast.lat, this.southwest.lat),
          lng: this.getCenterLocationFromLatLon(this.northeast.lng, this.southwest.lng)
        }
        this.zoom = this.calcZoom()
      } else {
        this.center = {
          lat: this.northeast.lat + (this.northeast.lat > 0 ? -0.0013489802915 : 0.0013489802915),
          lng: this.northeast.lng + (this.northeast.lng > 0 ? -0.0013489802915 : 0.0013489802915)
        }
        this.zoom = 16
      }
    },
    async history () {
      const api = new AccountApi()
      const result = await api.antifraud.timeline(this.seller.holder.id)
      if (!result.error) {
        this.timeline = result.timeline
      } else {
        const title = 'Ops'
        this.$alert.onClose = async () => this.$router.push({ name: 'antifraud' })
        this.$alert.error(title)
      }
    },
    async getAnalisys () {
      const api = new AntifraudApi()
      const result = await api.antifraud.find(this.$route.params.id)
      this.analisys = result.analisys
    },
    formatAddress (address) {
      return address.line1 + ', ' +
        (address.streetNumber ? address.streetNumber + ' - ' : null) +
        (address.line2 ? address.line2 + ' - ' : '') +
        (address.district ? address.district + ', ' : null) +
        (address.city ? address.city.name + ' - ' + address.city.state + ', ' : null) +
        address.zipCode
    },
    formatAddressForGoogleApi (address) {
      return address.line1 + ', ' +
        (address.streetNumber ? address.streetNumber + ' - ' : null) +
        (address.district ? address.district + ', ' : null) +
        (address.city ? address.city.name + ' - ' + address.city.state + ', ' : null) +
        address.zipCode
    },
    badgeTimeline (action) {
      switch (action) {
        case 'approved': return 'Conta aprovada em'
        case 'disapproved': return 'Conta reprovada em'
        case 'actived': return 'Conta reativada em'
        case 'inactived': return 'Conta encerrada em'
        case 'balanceBlocked': return 'Bloqueou o saldo'
        case 'balanceUnblocked': return 'Desbloqueou o saldo'
        case 'blacklist': return 'Adicionou na blacklist'
        case 'removedBlacklist': return 'Removeu da blacklist'
        case 'registered': return 'Cadastro realizado em'
        case 'request': return 'Alteração solicitada em'
        case 'updated': return 'Atualização de dados em'
        default: return 'Análise'
      }
    }
  }
}
</script>
